import { render, staticRenderFns } from "./EpcArrayWal.vue?vue&type=template&id=56ce365c&scoped=true&"
import script from "./EpcArrayWal.vue?vue&type=script&lang=js&"
export * from "./EpcArrayWal.vue?vue&type=script&lang=js&"
import style0 from "./EpcArrayWal.vue?vue&type=style&index=0&id=56ce365c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce365c",
  null
  
)

export default component.exports